import { jsx } from "react/jsx-runtime";
import { useIcon } from "../../hooks/useIcon/index.mjs";
import { Box } from "../Box/Box.mjs";
const IconContainer = ({
  children,
  verticalCorrection,
  ...props
}) => {
  const { isInline, svgProps } = useIcon(props, {
    verticalCorrection
  });
  return isInline ? /* @__PURE__ */ jsx(Box, { component: "span", display: "inlineBlock", children: children(svgProps) }) : children(svgProps);
};
export {
  IconContainer
};
